import { createSelector } from 'reselect';
import { selectActiveComponentIndex } from './search.selector';
import { updateRailMatrix } from '../../utils/filter.utils';

export const selectRailFeatureState = (state) => state.rail;

export const selectRailComponents = createSelector(
  selectRailFeatureState,
  (state) => state && state.components
);

export const selectActiveRailComponent = createSelector(
  selectRailComponents,
  selectActiveComponentIndex,
  (state, displayIndex) => state && state[displayIndex]
);

export const selectRailResponse = createSelector(
  selectActiveRailComponent,
  (state) => state && state.searchResults
);

export const selectRailResults = createSelector(
  selectRailResponse,
  (state) => state && state.Responses
);

export const selectRailBrandList = createSelector(
  selectActiveRailComponent,
  (state) => state && state.brandList
);

export const selectedRailBrand = createSelector(
  selectActiveRailComponent,
  (state) => state && state.selectedBrand
);

export const selectedRailBrandFilter = createSelector(
  selectActiveRailComponent,
  (state) => state && state.railBrandFilter
);

export const selectRailSort = createSelector(
  selectActiveRailComponent,
  (state) => state && state.railSort
);

export const selectRailVendors = createSelector(
  selectActiveRailComponent,
  (state) => state && state.filterByDetails
);

export const selectRailTimeMatrixFilterBy = createSelector(
  selectActiveRailComponent,
  (state) => state && state.railTimeMatrixFilterBy
);

export const selectRailListByVendors = createSelector(
  selectRailResults,
  selectRailVendors,
  (state, selectedVendors) => {
    if (!state) {
      return [];
    }
    const vendorList = selectedVendors.vendors.vendorGroups.items;
    return state.filter(function (train) {
      for (const key in vendorList) {
        if (vendorList[key].name === train.vendorName && vendorList[key].checked === true) {
          return true;
        }
      }
      return false;
    });
  }
);

export const selectRailListByBrands = createSelector(
  selectRailListByVendors,
  selectedRailBrandFilter,
  (state, selectedBrand) => {
    if (!state) {
      return [];
    }
    return state.filter(function (train) {
      return train.multiBrandFare.some(function (brand) {
        return brand.brandName === selectedBrand || selectedBrand === 'Lowest';
      });
    });
  }
);

export const selectRailListByTime = createSelector(
  selectRailListByBrands,
  selectRailTimeMatrixFilterBy,
  (state, selectedTimeMatrix) => {
    if (!state) {
      return [];
    }
    return state.filter(function (train) {
      switch (selectedTimeMatrix) {
        case 'MORNING':
          if (train.filterDepart >= 0 && train.filterDepart <= 105900) {
            return true;
          }
          break;
        case 'MIDDAY':
          if (train.filterDepart >= 110000 && train.filterDepart <= 135900) {
            return true;
          }
          break;
        case 'EVENING':
          if (train.filterDepart >= 140000 && train.filterDepart <= 235900) {
            return true;
          }
          break;
        default:
          return true;
      }
    });
  }
);

export const selectFilteredRailList = createSelector(
  selectRailListByTime,
  selectRailSort,
  (state, railSort) => {
    if (!state || !railSort) {
      return [];
    }
    if (railSort.asc) {
      return state.sort((a, b) => (a[railSort.sort] > b[railSort.sort] ? 1 : -1));
    } else {
      return state.sort((a, b) => (a[railSort.sort] < b[railSort.sort] ? 1 : -1));
    }
  }
);

export const selectRailBottomBar = createSelector(selectRailListByBrands, (state) => {
  if (!state) {
    return [];
  }
  const matrixList = updateRailMatrix(state);
  return matrixList;
});
